import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {dataRegister} from "../../services/dataRegister";
import queryString from "query-string";
import {themeRegister} from "../../services/themeRegister";
import {videoRegisterNew} from "../../services/videoRegisterNew";

class SignupAdsTiktok extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selected: false,
            learn_more: false,
            quotes: null,
            market: null,
            image: null,
            tips: [],
            industry: {},
            customIndustry: null,
            ad_types: {
                canvas: {available: true, selected: true},
                carousel: {available: true, selected: false},
                video: {available: true, selected: false}
            },
            carousel: [],
            video: null,
            available: false,
            theme: null
        };
    };

    componentDidMount() {
        this._updateData();
        this._updateTheme();
    }

    _updateData() {
        this.setState({
            tips: [
                {title: this._renderText("item_68")},
                {title: this._renderText("item_69")},
                {title: this._renderText("item_70")},
                {title: this._renderText("item_71")},
                {title: this._renderText("item_72")},
                {title: this._renderText("item_73")}
            ],
            selected: this.props.setChannel,
            quotes: this.props.setQuotes,
            industry: this.props.setIndustry,
            customIndustry: this.props.setCustomIndustry,
            image: this.props.setImage,
            market: salesChannelRegister.get('market'),
            available: this.props.setAvailable
        });
    }

    _updateTheme(){
        this.setState({
            theme: themeRegister.getTheme()
        });
    }

    _placement(){
        try{
            let query = {
                industry: this.state.industry.name,
                region: salesChannelRegister.get("market"),
                quotes: "| " + this._renderQuotes(),
                website: this._renderText("item_60") + salesChannelRegister.get("market"),
                image: this.state.image.url,
                saleschannel: salesChannelRegister.get("name"),
                pageTitle: salesChannelRegister.get('socialTitle'),
                pageImage: salesChannelRegister.get('socialIcon')
            };

            const stringified = queryString.stringify(query);
            let url = 'https://placement.'+dataRegister.domain;
            if(dataRegister.domain === "localhost"){
                url = 'https://placement.devsaleschannel.com';
            }
            var popUp = window.open(url +"/"+langRegister.lang()+"/tiktok?" + stringified, '_blank');
        }catch (e) {
            window.open('https://placement.'+dataRegister.domain+"/"+langRegister.lang()+"/tiktok", '_blank');
        }
    }

    _selectAdType(item){
        try {
            for(let key in this.state.ad_types){
                if(key === item){
                    this.state.ad_types[key].selected = true;
                }else{
                    this.state.ad_types[key].selected = false;
                }
            }
            this.setState({ad_types: this.state.ad_types})
        }catch (e) {
            console.log(e);
        }
    }

    _renderQuotes() {
        if (this.state.quotes) {
            let quotes_string = "";
            if (!this.state.quotes.custom) {
                let i = 1;
                var sortable = [];
                for (var key in this.state.quotes) {
                    sortable.push([this.state.quotes[key], this.state.quotes[key].index]);
                }
                sortable.sort(function(a, b) {
                    return a[1] - b[1];
                });
                sortable.map((item) => {
                    quotes_string += item[0].slogan + (sortable.length > i ? " - " : "");
                    i++;
                });

                if(this.state.customIndustry){
                    quotes_string = this.state.customIndustry + " | " + quotes_string;
                }

            } else {
                quotes_string = this.state.quotes.text;
            }
            return quotes_string
        }
    }

    _renderCustomVideo(){
        let video = videoRegisterNew.getCustom();
        return video.url;
    }

    _renderText(item) {
        return langRegister.get("signup-ads", item);
    }

    render() {
        return (
            <div className={Styles.contentContainerLeftItem}>
                {
                    this.state.selected && this.state.available &&
                    <div onClick={() => this._placement()} className={Styles.contentContainerLeftItemPlacement}>
                        <img src={require("../../assets/images/plus_sign_white_small.png")} className={Styles.contentContainerLeftItemPlacementIcon}/>
                    </div>
                }
                <div className={
                         cx(Styles.contentContainerLeftItemInner,
                             {
                                 [Styles.contentContainerLeftItemInnerActive]: !this.state.selected,
                             })
                     }>
                    <div
                        className={
                            cx(Styles.contentContainerLeftItemInnerOverlay,
                                {
                                    [Styles.contentContainerLeftItemInnerOverlayActive]: !this.state.selected,
                                })
                        }
                    >
                        {
                            !this.state.selected &&
                            <div onClick={() => {
                                if(this.state.available){
                                    this.props.selectChannel("tiktok"); this.setState({selected: !this.state.selected})
                                }
                            }}
                                 className={
                                     cx(Styles.contentContainerLeftItemInnerOverlayButton,
                                         {
                                             [Styles.contentContainerLeftItemInnerOverlayButtonComing]: !this.state.available,
                                         })
                                 }>
                                {
                                    this.state.available &&
                                    this._renderText("item_18")
                                }
                                {
                                    !this.state.available &&
                                    this._renderText("item_67")
                                }
                            </div>
                        }
                        <div className={Styles.contentContainerLeftItemInnerOverlayTitle}>
                            TikTok <span className={Styles.contentContainerLeftItemInnerOverlayTitleSmall}>social ads</span>
                        </div>
                        {
                            this.state.tips.filter((item, key) => {
                                return !this.state.learn_more && key < 3 || this.state.learn_more && key > 2
                            }).map((prop, i) => {
                                return (
                                    <div key={i}
                                         className={Styles.contentContainerLeftItemInnerOverlayItem}>
                                        &#x2b; {prop.title}
                                    </div>
                                )
                            })
                        }
                        <div onClick={() => {this.setState({learn_more: !this.state.learn_more})}} className={Styles.contentContainerLeftItemInnerOverlayReadMore}>
                            {
                                this.state.learn_more &&
                                <span>{this._renderText("item_28")}</span>
                            }
                            {
                                !this.state.learn_more &&
                                <span>{this._renderText("item_29")}</span>
                            }
                        </div>
                    </div>
                    <div className={Styles.contentContainerLeftItemTiktokInnerTop}>
                </div>
                </div>
                <div className={Styles.contentContainerLeftItemBottom}>
                    <div
                        className={
                            cx(Styles.contentContainerLeftItemBottomIconContainer,
                                {
                                    [Styles.contentContainerLeftItemBottomIconContainerActive]: this.state.selected,
                                })
                        }
                    >
                        <img
                            className={Styles.contentContainerLeftItemBottomIconContainerIconTiktok}
                            src={require("../../assets/images/tiktok_logo_icon.svg")}/>
                    </div>
                    {
                        !this.state.selected && this.state.available &&
                        <img onClick={() => {this.props.selectChannel("tiktok"); this.setState({selected: !this.state.selected}, () => {if(!this.state.selected){this._selectAdType("canvas")}})}}
                             className={Styles.contentContainerLeftItemBottomSlider}
                             src={require("../../assets/images/slider_deactive.svg")}/>
                    }
                    {
                        this.state.selected && this.state.available &&
                        <img onClick={() => {this.props.selectChannel("tiktok"); this.setState({selected: !this.state.selected}, () => {if(!this.state.selected){this._selectAdType("canvas")}})}}
                             className={Styles.contentContainerLeftItemBottomSlider}
                             src={require("../../assets/images/slider_active.svg")}/>
                    }
                    {
                        !this.state.selected && !this.state.available &&
                        <div className={Styles.contentContainerLeftItemBottomDots}>
                            <div className={
                                cx(Styles.contentContainerLeftItemBottomDotsItem,
                                    {
                                        [Styles.contentContainerLeftItemBottomDotsItemActive]: !this.state.learn_more,
                                    })
                            }/>
                            <div className={Styles.contentContainerLeftItemBottomDotsItemLine}/>
                            <div className={
                                cx(Styles.contentContainerLeftItemBottomDotsItem,
                                    {
                                        [Styles.contentContainerLeftItemBottomDotsItemActive]: this.state.learn_more,
                                    })
                            }/>
                        </div>
                    }
                    {
                        this.state.selected && this.state.available &&
                        <div className={Styles.contentContainerLeftItemBottomShowBoxes}>
                            {
                                this.state.ad_types.canvas.available &&
                                <div className={
                                    cx(Styles.contentContainerLeftItemBottomShowBoxesItem,
                                        {
                                            [Styles.contentContainerLeftItemBottomShowBoxesItemActive]: this.state.ad_types.canvas.selected,
                                        })
                                } onClick={() => this._selectAdType("canvas")}>
                                    <img className={Styles.contentContainerLeftItemBottomShowBoxesItemIcon} src={require("../../assets/images/AB_Ad_Image.png")}/>
                                </div>
                            }
                            {
                                this.state.ad_types.video.available && ((this.state.theme === "custom" && this._renderCustomVideo()) || this.state.theme !== "custom") &&
                                <div className={
                                    cx(Styles.contentContainerLeftItemBottomShowBoxesItem,
                                        {
                                            [Styles.contentContainerLeftItemBottomShowBoxesItemActive]: this.state.ad_types.video.selected,
                                        })
                                } onClick={() => this._selectAdType("video")}>
                                    {
                                        <img className={Styles.contentContainerLeftItemBottomShowBoxesItemIconVideo} src={require("../../assets/images/AB_Ad_Video.png")}/>
                                    }
                                </div>
                            }
                            {
                                this.state.ad_types.carousel.available &&
                                <div className={
                                    cx(Styles.contentContainerLeftItemBottomShowBoxesItem,
                                        {
                                            [Styles.contentContainerLeftItemBottomShowBoxesItemActive]: this.state.ad_types.carousel.selected,
                                        })
                                } onClick={() => this._selectAdType("carousel")}>
                                    <img className={Styles.contentContainerLeftItemBottomShowBoxesItemIcon} src={require("../../assets/images/AB_Ad_Carusel.png")}/>
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default SignupAdsTiktok;


// WEBPACK FOOTER //
// ./src/components/signup-ads-tiktok/component.js